import { Component, AfterViewInit, Renderer2, Inject } from '@angular/core';
import { AppAnunciosService } from '../../../core/services/appAnunciosService.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { AppAnuncios } from '../../../core/models/appAnuncios.model';
import { MatDialog } from '@angular/material/dialog';
import { AnunciosEditDialog } from '../anuncios-edit-dialog/anuncios-edit-dialog.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-anuncios-list',
  templateUrl: './anuncios-list.component.html',
  styleUrls: ['./anuncios-list.component.scss'],
  providers: [AppAnunciosService]
})
export class AnunciosListComponent extends ListFormBase<AppAnuncios> implements AfterViewInit {

  panelIcon = 'newspaper'; // Material icon
  panelTitle = 'Anuncios';
  panelDescription = 'Listado de los anuncios dado un entorno'

  constructor(
    protected _modelService: AppAnunciosService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _anunciosEditDialog: MatDialog,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(_modelService, _router, _route, _messageDialog, AppAnuncios);
    this.isCrud = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource();
      
    });
  }

  /* comportamiento para que se muestre si/no en vez de un checkbox */
  transformBooleanToYesNo(data: any): string {
    return data && data.enabled ? 'Si' : 'No';
  }

  getDisplayCompanyName(data: any): string {

    return data.companies.length == 1 ? data.companies[0].name : 'Varias Empresas';
  }

  calculatePublished(data: any): string {
    return data && data.published ? 'Publicado' : 'Borrador';
  }

  onClickEdit(e) {
    const dialogRef = this._anunciosEditDialog.open(AnunciosEditDialog, {
      width: '100%',
      data: e
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.getDataSource();
    });
  }

  unpublishAnnouncement(data: any) {
    this._messageDialog.ShowQuestion(
      `El anuncio pasará al estado de "Borrador", y no será visible para los empleados de las empresas a las que esté asignado`,
      'Retirar anuncio'
    )
      .then(result => {
        if (result.value && data.published === true) {

          let dataToSend = {
            published: false
          }
          this._modelService.updateModel(data.announcement1, dataToSend).subscribe(
            (result) => {

              setTimeout(() => {
                this.getDataSource();
              }, 1500);
            }, (error) => {
              this._messageDialog.ShowAlert(
                `Se ha producido un error al retirar el anuncio`,
                `Error al  al retirar el anuncio`);

              console.error(`Error al retirar anuncio ${data}`, error);
            }

          )
        }
      });



  }


}



